import {definePreset} from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{indigo.50}',
      100: '{indigo.100}',
      200: '{indigo.200}',
      300: '{indigo.300}',
      400: '{indigo.400}',
      500: '{indigo.500}',
      600: '{indigo.600}',
      700: '{indigo.700}',
      800: '{indigo.800}',
      900: '{indigo.900}',
      950: '{indigo.950}'
    }
  },
  // components: {
  //   button: {
  //     colorScheme: {
  //       light: {
  //         root: {
  //           primary: {
  //             background: "{primary.500}"
  //           }
  //         },
  //         subtitle: {
  //           color: '{surface.500}'
  //         }
  //       },
  //       dark: {
  //         root: {
  //           background: '{surface.900}',
  //           color: '{surface.0}'
  //         },
  //         subtitle: {
  //           color: '{surface.400}'
  //         }
  //       }
  //     }
  //   }
  // }
});

export default MyPreset
